<header>
  <div class="header-r1">
    <a href="https://www.sony.com/en" target="_blank" title="Sony"
      ><img class="logo-1" [src]="logoPath1" [alt]="'Sony Logo'"
    /></a>
  </div>
</header>
<div class="maintenance-wrapper">
  <div class="maintenance-content">

    <p class="brand-name"><img [src]="logoPath2" [alt]="'Sony Pictures'" /></p>

    <h1 class="maintenance-heading">We'll be back <br> soon!</h1>

    <p class="maintenance-body">
      <strong>Global Asset Hub is temporarily unavailable while we make improvements to the site experience.</strong><br>
      The updated site will launch on <strong>June 8th</strong>, and your existing URL will remain unchanged.<br>
      Thank you for your patience. If you need assistance in the meantime, please contact us.
    </p>

    <a  mat-raised-button href="mailto:GlobalAssetHub_Support@spe.sony.com" class="contact-btn">
        <mat-icon>mail_outline</mat-icon>
        Contact Us
    </a>

  </div>
</div>

<footer>
  <div class="footer">
    <span>&copy; {{ currentYear }} Sony Pictures Entertainment Inc. All Rights Reserved.</span>
    <div class="footer__links">
      <a class="footer__link" href="mailto:GlobalAssetHub_Support@spe.sony.com">Contact Us</a>
      <a class="footer__link" href="https://intl.sonypictures.com" target="_blank">Privacy Policy</a>
    </div>
    <div class="nav">
      <div class="nav--connect">
        <a
          id="social-1"
          class="nav__link"
          [href]=" 'https://www.facebook.com/SonyPictures'"
          target="_blank"
          rel="noopener"
          ><span class="icn-facebook sprite-icon"></span
          ><span class="visuallyhidden">Facebook</span></a
        >
        <a
          id="social-2"
          class="nav__link"
          href="https://www.linkedin.com/company/sony-pictures-entertainment"
          target="_blank"
          rel="noopener"
          ><span class="icn-linkedin sprite-icon"></span
          ><span class="visuallyhidden">LinkedIn</span></a
        >
        <a
          id="social-3"
          class="nav__link"
          [href]="'https://x.com/SonyPictures'"
          target="_blank"
          rel="noopener" 
          ><i title="X" class="fa-brands fa-x-twitter"></i></a
        >
        <a
          id="social-4"
          class="nav__link"
          [href]="'https://www.instagram.com/SonyPictures/'"
          target="_blank"
          rel="noopener"
          ><span class="icn-instagram sprite-icon"></span
          ><span class="visuallyhidden">Instagram</span></a
        >
        <a
          id="social-5"
          class="nav__link"
          [href]="'https://www.youtube.com/sonypictures'"
          target="_blank"
          rel="noopener"
          ><span class="icn-youtube sprite-icon"></span
          ><span class="visuallyhidden">Youtube</span></a
        >
      </div>
    </div>
  </div>
</footer>
